'use client'

import Box from '@mui/material/Box'

import { BookingFooter } from '@/src/components/layout/BookingFooter'
import { BookingHeader } from '@/src/components/layout/BookingHeader'

interface WizardLayoutProps {
  progressBar: React.ReactNode
  children: React.ReactNode
}

export const WizardLayout: React.FC<WizardLayoutProps> = ({ progressBar, children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header */}
      <BookingHeader />

      {/* Progress bar */}
      {progressBar}

      {/* Step content */}
      <Box
        component="main"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          py: { xs: 5, md: 11.25 },
          px: { xs: 2, md: 12.5 }
        }}
      >
        {children}
      </Box>

      {/* Footer */}
      <BookingFooter />
    </Box>
  )
}
